/**
 * Copyright 2021 GeoComply
 * Author: Hao Nguyen (hao@geocomply.com)
 * 
 * GeoComply React Native Module Promise status
 * 
 * List of statuses:
 * 
 * - STATUS_FAILED: Indicates a Promise reject when calling GeoComply React Native Module APIs.
 * 
 * - STATUS_SUCCESS: Indicates a Promise resolve when calling GeoComply React Native Module APIs.
 * 
 */

export const STATUS_FAILED 	= 0
export const STATUS_SUCCESS = 1
